import { call, put } from 'redux-saga/effects';
import { GET_ESG_COVERAGE_DATA_SUCCESS, GET_ESG_COVERAGE_DATA_ERROR } from './esgCoverageActions';
import { getEsgCoverage } from '../../modules/ESG/services/esgLendingService';

export function* fetchEsgCoverageDataSaga({ payload }) {
  try {
    const response = yield call(getEsgCoverage, payload);
    yield put({ type: GET_ESG_COVERAGE_DATA_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_ESG_COVERAGE_DATA_ERROR, payload: response });
  }
}
